import Trashcan from 'assets/icons/fa/trash.svg'

Trashcan.displayName = 'Trashcan'
export default Trashcan
